module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray@3x-9c3e615adb9f150a3420ec0864d1cc80.png";